export const OPEN_SEGMENT = "OPEN_SEGMENT";
export const OPEN_PAIRING = "OPEN_PAIRING";

export const OPEN_FLYING_DATA_STATUS = {
  YET_TO_FETCH: "YET_TO_FETCH",
  FETCHING: "FETCHING",
  FETCHED: "FETCHED"
};
